import useProductCardImage from '~/hooks/components/useProductCardImage';
import GenericProductCard from '~/components/GenericProductCard';
import { useMemo } from 'react';
import useCalculatedKitSavingsByArray from '~/hooks/components/use-calculated-kit-savings-by-array';
import { ThemeUIStyleObject } from 'theme-ui';
import { Image } from '~/types';

type Props = {
  kit: Queries.KitCardFragmentFragment;
  forwardSx?: ThemeUIStyleObject;
  wrapperSx?: ThemeUIStyleObject;
  collectionSlug?: string;
  bgColor?: string;
  isFeatured?: boolean;
  cardDirection?: boolean | null;
  cdpCopy?: string;
  mainImage?: Image;
  featuredImage?: Image;
  cardMicroloadHighlight?: string;
  renderPrice?: boolean;
  badgeColor?: string;
};

const KitCard = ({
  kit,
  forwardSx = {},
  wrapperSx = {},
  collectionSlug,
  bgColor = 'white',
  isFeatured,
  cardDirection,
  cdpCopy,
  mainImage,
  featuredImage,
  cardMicroloadHighlight,
  renderPrice,
}: Props) => {
  const { productCardImage: currentImage } = useProductCardImage({
    desktopImage: isFeatured ? featuredImage ?? mainImage : mainImage,
    mobileImage: mainImage,
  });
  const products = kit.products;
  const { badge } = kit;
  const kitProductVariantSkuArray = useMemo(() => {
    const skuReduceArray = products?.map((product) => product?.variants?.[0]?.sku);
    return skuReduceArray;
  }, [products]);

  const calculatedKitSavings = useCalculatedKitSavingsByArray(
    kitProductVariantSkuArray ?? [],
    kit?.price ?? 0,
    products
  );

  return (
    <GenericProductCard
      isFeatured={isFeatured}
      cardDirection={cardDirection}
      title={kit.name}
      bgColor={bgColor}
      calculatedKitSavings={kit.hideSavingsTag ? 0 : calculatedKitSavings}
      forwardSx={forwardSx}
      wrapperSx={wrapperSx}
      price={kit.price}
      regularPrice={kit.price} // Don't want to render this on kits
      slug={kit.slug}
      name={kit.name}
      collectionSlug={collectionSlug ?? kit.collection?.[0]?.slug}
      badge={badge}
      currentImage={currentImage}
      cardMicroloadHighlight={cardMicroloadHighlight}
      cdpCopy={cdpCopy}
      renderPrice={renderPrice}
    />
  );
};

export default KitCard;
